import { RO_DETAILS_TAB } from "@/hooks/useRoPanelParams";

/**
 * Picks the side-panel tab to show.
 *
 * A remembered or deep-linked tab can name one this shop has hidden behind a
 * feature flag or `shopConfig.inboxPanel.*`. Radix Tabs renders an empty panel
 * for a value with no trigger, so anything not on screen falls back to the
 * first tab that is. RO Details has no flag or config gate, so it is the
 * backstop.
 */
export const resolvePanelTab = (
  activeTab: string | null,
  visibleTabs: string[]
): string => {
  if (activeTab && visibleTabs.includes(activeTab)) {
    return activeTab;
  }
  return visibleTabs[0] ?? RO_DETAILS_TAB;
};
